export default __webpack_public_path__ + "static/images/sound_false.ecb0f5a6.png";